module.exports = __webpack_public_path__ + "media/assets/images/fake-simulation-fr-97d57a6eebe31e486b35f0d52c932250.png";